module.exports = __webpack_public_path__ + "img/overview-investors.d9ce40a9.svg";